module.exports = __webpack_public_path__ + "static/media/news-aptihealth-pandion.76cbb20c.jpg";